<template>
	<span
		class="status-data-dot"
		:class="cls"
		:title="value"
	/>
</template>
<script setup lang="ts">
	import { computed } from "vue";
	const props = defineProps<{ value: string }>();
	const cls = computed(() => {
		const v = (props.value || "").toLowerCase();
		return v === "online" ? "ok" : v === "maintenance" ? "warn" : v === "error" ? "err" : "off";
	});
</script>
